import {useParams} from '@eitje/bridge'
import {ApiConsumer, useGet} from '@eitje/api'
import {ArrayField, Input, LegacyFormModal} from '~/components'

const emailArrayFieldFields = [{Component: Input, field: 'email', readOnly: true}]

export const ApiConsumerDetails = () => {
	const {id} = useParams()
	const apiConsumer = ApiConsumer.useFind(id)
	const {data, loading} = useGet(`api_consumers/${id}/password`)
	const emails = apiConsumer.emails.map(email => ({email}))

	if (loading) return null

	return (
		<LegacyFormModal
			name="api_consumer"
			initialValues={{
				partner_username: apiConsumer.partner_username,
				emails,
				password: data.item.partner_password,
			}}
			modalProps={{hideSubmit: true}}
			width={400}
		>
			<Input field="partner_username" readOnly />
			<ArrayField field="emails" fields={emailArrayFieldFields} minItems={emails.length} readOnly />
			<Input field="password" readOnly />
		</LegacyFormModal>
	)
}
